module.exports = __webpack_public_path__ + "img/login-img6.3d41e792.png";